<template>
    <c-dialog ref="dialog" width="550" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="editHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="客户" required >
                <c-select name="customer_id" async @search="searchCustomer" :value-data="selectedCustomer"  :disabled="fastAdd"></c-select>
            </c-form-item>

            <c-form-item label="地址位置" required>
                <c-location lng-name="longitude" lat-name="latitude" address-name="address_detail"></c-location>
            </c-form-item>

            <c-form-item label="启用状态" required>
                <c-radio-group name="enable_status" :options="disableEnableDic"></c-radio-group>
            </c-form-item>

            <c-form-item label="备注">
                <c-input name="remark" type="textarea" maxlength="500" :rows="3"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['disableEnableDic'])
    },
    data() {
        return {
            fastAdd:false,                  //是否是客户详情页直接添加客户地址
            selectedCustomer: [],
            editState: false
        }
    },

    methods: {
        async open(data) {
            this.$refs.form.clear();
            this.selectedCustomer = [];
            this.editState = false;
            if (data) {
                this.request({
                    url: '/customer/address/detail',
                    data: { id: data.id },
                    success: res => {
                        this.$refs.form.set(res);
                        if (res.customer_id && res.customer_name) {
                            this.selectedCustomer = [{
                                name: res.customer_name,
                                value: res.customer_id
                            }];
                        }
                    }
                });
                this.editState = true;
            } else {
                this.$refs.form.set({
                    enable_status: 1
                });
            }
            this.$refs.dialog.open({
                title: data ? '编辑常用地址' : '新增常用地址'
            });
        },

        openForAdd(data,id) {
            this.fastAdd = true;
            this.editState = false;
            //清空表单数据
            this.$refs.form.clear();
            if (id){
                this.request({
                    url: '/customer/address/detail',
                    data: { id:id },
                    success: res => {
                        this.$refs.form.set(res);
                    }
                });
            }
            //处理选中的【客户信息】
            this.selectedCustomer = [{
                name: data.customer_name,
                value: data.id
            }];
            this.$refs.dialog.open({
                title: '新增常用地址'
            });
        },

        searchCustomer(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: { options_code: 'CUSTOMER', keyword: keyword },
                success: data => resolve(data)
            });
        },

        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: this.editState ? '/customer/address/update' : '/customer/address/add',
                rule: {
                    customer_id: '请选择客户',
                    address_detail: '请输入或选择地址详情',
                    longitude: '请输入定位经度',
                    latitude: '请输入定位纬度'
                },
                dataFormatter: data => {
                    const c = this.selectedCustomer && this.selectedCustomer[0];
                    if (c) {
                        data.customer_id = c.value;
                    }
                    return data;
                },
                success: () => {
                    next();
                    this.$message({
                        message: this.editState ? '编辑成功' : '新增成功',
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
